import React, { Fragment, useContext, useState } from "react";
import * as styles from "./magazine.module.css";
import { StatusType } from "../../services/firebase/auth-context/reducer";
import AuthContext from "../../services/firebase/auth-context/provider";
import Login from "../login/login";
import { toEuroString } from "../../util/format/euro";
import MagazineBuyForm from "../forms/magazines/form";
import LoadingSpinner from "../common/loading-spinner";
import MakroAlert, { MakroAlertType } from "../common/alert";
import { buyMagazine } from "../../services/monsum/magazines/buy";
export var MagazineBuyState;
(function (MagazineBuyState) {
    MagazineBuyState[MagazineBuyState["INACTIVE"] = 0] = "INACTIVE";
    MagazineBuyState[MagazineBuyState["BUY"] = 1] = "BUY";
    MagazineBuyState[MagazineBuyState["BUY_AGAIN"] = 2] = "BUY_AGAIN";
})(MagazineBuyState || (MagazineBuyState = {}));
var MagazineBuy = function MagazineBuy(_ref) {
    var number = _ref.number, price = _ref.price, soldOut = _ref.soldOut, onlyDigital = _ref.onlyDigital, setBuyState = _ref.setBuyState;
    var _useContext$ = useContext(AuthContext)[0], authenticated = _useContext$.authenticated, userData = _useContext$.userData;
    var _useState = useState("none"), resultState = _useState[0], setResultState = _useState[1];
    var _useState2 = useState(false), buyRequestIsSubmitting = _useState2[0], setBuyRequestIsSubmitting = _useState2[1];
    var onSuccess = function onSuccess() {
        setResultState("success");
        setTimeout(function () {
            setBuyState(MagazineBuyState.INACTIVE);
            window.location.reload();
        }, 5000);
    };
    var buyRequest = function buyRequest(data) {
        setBuyRequestIsSubmitting(true);
        buyMagazine({
            number: number,
            customer: null,
            payment: null,
            legal: null
        }).then(function (res) {
            res ? onSuccess() : setResultState("failure");
            setBuyRequestIsSubmitting(false);
        }).catch(function () {
            setResultState("failure");
            setBuyRequestIsSubmitting(false);
        });
    };
    var onSubmit = function onSubmit(values, _ref2) {
        var setSubmitting = _ref2.setSubmitting;
        setSubmitting(true);
        buyMagazine(mapRequestData(number, values)).then(function (res) {
            setSubmitting(false);
            if (res) {
                onSuccess();
            }
            else {
                setResultState("failure");
            }
        }).catch(function () {
            setSubmitting(false);
            setResultState("failure");
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.buyBox
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap mb-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex-1"
    }, /*#__PURE__*/ React.createElement("strong", null, "Erwerben Sie dieses Themenheft"), /*#__PURE__*/ React.createElement("br", null), renderProductDescription(price, soldOut, onlyDigital)), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-center"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return setBuyState(MagazineBuyState.INACTIVE);
        },
        className: "text-sm italic"
    }, "Abbrechen"))), resultState === "success" ? renderAlertSuccess(soldOut, onlyDigital) : resultState === "failure" ? renderAlertFailure() : !authenticated ? /*#__PURE__*/ React.createElement(Login, null) : isLoading(userData) ? /*#__PURE__*/ React.createElement(LoadingSpinner, null) : isCustomer(userData) ? renderBuy(price, soldOut, onlyDigital, buyRequest, buyRequestIsSubmitting) : /*#__PURE__*/ React.createElement(MagazineBuyForm, {
        onSubmit: onSubmit,
        submitButtonText: buyButtonText(price, soldOut, onlyDigital)
    }));
};
var isLoading = function isLoading(userData) {
    return userData && userData.status === StatusType.LOADING;
};
var isCustomer = function isCustomer(userData) {
    return userData && userData.status === StatusType.SUCCESS && userData.data.customerId;
};
var renderProductDescription = function renderProductDescription(price, soldOut, onlyDigital) {
    return /*#__PURE__*/ React.createElement("small", null, "(", soldOut || onlyDigital ? "Digital" : "Print & Digital", "-Version f\xFCr ", toEuroString(price), ")");
};
var buyButtonText = function buyButtonText(price, soldOut, onlyDigital) {
    return /*#__PURE__*/ React.createElement("strong", null, soldOut || onlyDigital ? "Digital" : "Print & Digital", "-Version f\xFCr ", toEuroString(price), " kaufen");
};
var renderBuy = function renderBuy(price, soldOut, onlyDigital, buyFunction, isSubmitting) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "text-center py-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center mx-auto mb-3",
        style: {
            maxWidth: "390px"
        }
    }, "Mit Klick auf den nachfolgenden Button best\xE4tigen Sie, dass Sie die ", /*#__PURE__*/ React.createElement("a", {
        href: "/agb",
        target: "_blank",
        className: "text-makroOrange underline hover:no-underline"
    }, "AGB"), " zur Kenntnis genommen haben."), !isSubmitting ? /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return buyFunction();
        },
        className: "btn-makroPurple"
    }, buyButtonText(price, soldOut, onlyDigital)) : /*#__PURE__*/ React.createElement(LoadingSpinner, null));
};
var renderAlertSuccess = function renderAlertSuccess(soldOut, onlyDigital) {
    return /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.SUCCESS,
        title: "Vielen Dank!",
        text: "Sie haben das Themenheft erfolgreich erworben. Sie werden in wenigen Sekunden weitergeleitet und k\xF6nnen das Themenheft herunterladen." + (soldOut || onlyDigital ? "" : " Zudem erhalten Sie die Print-Version in den nächsten Tagen per Post.")
    });
};
var renderAlertFailure = function renderAlertFailure() {
    return /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.DANGER,
        title: "Das hat leider nicht geklappt",
        text: /*#__PURE__*/ React.createElement(Fragment, null, "Es ist ein Fehler aufgetreten. Wir helfen Ihnen gerne weiter: ", /*#__PURE__*/ React.createElement("a", {
            href: "mailto:technik@makroskop.eu",
            className: "underline"
        }, "technik@makroskop.eu"), ".")
    });
};
var mapRequestData = function mapRequestData(magazineNumber, values) {
    return {
        number: magazineNumber,
        customer: {
            salutation: values.customer.salutation,
            firstName: values.customer.firstName,
            lastName: values.customer.lastName,
            email: values.customer.email,
            street: values.customer.street,
            zipcode: values.customer.postalCode,
            city: values.customer.city,
            country: values.customer.country
        },
        payment: {
            method: values.payment_method.method,
            bankAccountOwner: values.payment_method.account_owner,
            bankName: values.payment_method.bank,
            bankBIC: values.payment_method.bic,
            bankIBAN: values.payment_method.iban,
            paymentToken: values.payment_method.stripe_token
        },
        legal: {
            agb: values.legal.agb,
            privacy: values.legal.privacy
        }
    };
};
export default MagazineBuy;
